import { Box, Button, Card, CardContent, Stack } from '@mui/material';
import { Link as ReactRouterLink, useRouteMatch } from 'react-router-dom';

import { Text, type api } from 'common';

import { FlowTemplateCardThumbnail } from './Card/Thumbnail';
import {
  FEATURED_FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS,
  MAX_TEMPLATE_NAME_DISPLAY_LENGTH,
} from './constants';
import { EventAction, EventCategory, useCaptureEvents } from '../../../../utils/events/index';

interface FlowTemplateFeaturedCardProps {
  flowTemplate: Pick<
    api.FlowDefinitionTemplate.FlowDefinitionTemplate,
    'id' | 'name' | 'content' | 'thumbnailUrl' | 'metadata'
  >;
}

export function FlowTemplateFeaturedCard(props: FlowTemplateFeaturedCardProps) {
  const {
    flowTemplate: { id, name, content, thumbnailUrl, metadata },
  } = props;

  const match = useRouteMatch();
  const { captureEvent } = useCaptureEvents();

  return (
    <Card
      sx={{
        height: FEATURED_FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS,
        borderRadius: 2,
      }}
      variant="outlined"
    >
      <Stack direction="row" sx={{ height: '100%' }}>
        <CardContent sx={{ width: '40%', alignContent: 'center' }}>
          <Stack gap={3} padding={2} sx={{ height: '100%', justifyContent: 'space-evenly' }}>
            <Stack gap={1}>
              <Text color="text.secondary" variant="body2">
                Featured Template
              </Text>
              <Text
                variant="heading2"
                bold
                sx={{
                  lineHeight: 1.2,
                  maxHeight: '88px',
                  overflow: 'hidden',
                  lineClamp: 3,
                }}
              >
                {name.length > MAX_TEMPLATE_NAME_DISPLAY_LENGTH
                  ? `${name.slice(0, MAX_TEMPLATE_NAME_DISPLAY_LENGTH)}...`
                  : name}
              </Text>
            </Stack>
            <Text
              variant="body2"
              sx={{
                maxHeight: '80px',
                overflow: 'hidden',
                lineClamp: 4,
              }}
            >
              {content}
            </Text>
            <Box>
              <Button
                variant="contained"
                color="primary"
                component={ReactRouterLink}
                to={`${match.url}/${id}`}
                onClick={() => {
                  captureEvent({
                    category: EventCategory.FlowDefinitionTemplate,
                    action: EventAction.HeroClick,
                    properties: {
                      templateId: id,
                      templateName: name,
                    },
                  });
                }}
              >
                View Template
              </Button>
            </Box>
          </Stack>
        </CardContent>
        <FlowTemplateCardThumbnail
          image={thumbnailUrl}
          imageTimestamp={metadata?.featuredTimestamp}
          borderRadius={2}
          width="60%"
        />
      </Stack>
    </Card>
  );
}
